import React, { useEffect } from 'react';
import { IcoCheck } from '../dashboard/DashIcons';

const EditModal = ({ entry, onChange, onCancel, onSubmit }) => {
  if (!entry) return null;

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);

  const totalHours =
    (parseFloat(entry.reg) || 0) +
    (parseFloat(entry.ot1) || 0) +
    (parseFloat(entry.ot2) || 0);

  const inputStyle = {
    padding: '0.75rem',
    border: '1px solid #d1d5db',
    borderRadius: '6px',
    fontSize: '1rem',
    width: '100%',
    boxSizing: 'border-box'
  };

  const labelStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.4rem',
    fontWeight: '500',
    color: '#374151'
  };

  return (
    <div style={modalStyle} role="dialog" aria-modal="true" aria-labelledby="edit-modal-title">
      <form onSubmit={onSubmit} style={formStyle}>
        <h2 id="edit-modal-title" style={{ fontSize: '1.5rem', fontWeight: '700', color: '#111827', marginBottom: '0.5rem' }}>
          Edit Time Entry
        </h2>

        {/* Name (read-only) */}
        <label style={labelStyle}>
          Employee
          <input
            type="text"
            value={entry.name || ''}
            readOnly
            style={{ ...inputStyle, backgroundColor: '#f9fafb', color: '#6b7280' }}
          />
        </label>

        {/* Date */}
        <label style={labelStyle}>
          Date*
          <input
            type="date"
            value={entry.date?.substring(0, 10) || ''}
            onChange={e => onChange({ ...entry, date: e.target.value })}
            required
            style={inputStyle}
          />
        </label>

        {/* Hours grid */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
          <label style={labelStyle}>
            REG Hours
            <input
              type="number"
              step="0.01"
              min="0"
              value={entry.reg || ''}
              onChange={e => onChange({ ...entry, reg: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            OT1 (1.5x)
            <input
              type="number"
              step="0.01"
              min="0"
              value={entry.ot1 || ''}
              onChange={e => onChange({ ...entry, ot1: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            OT2 (2x)
            <input
              type="number"
              step="0.01"
              min="0"
              value={entry.ot2 || ''}
              onChange={e => onChange({ ...entry, ot2: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            Sick Hours
            <input
              type="number"
              step="0.01"
              min="0"
              value={entry.sic || ''}
              onChange={e => onChange({ ...entry, sic: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            PTO Hours
            <input
              type="number"
              step="0.01"
              min="0"
              value={entry.pto || ''}
              onChange={e => onChange({ ...entry, pto: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            Total Hours
            <input
              type="number"
              step="0.01"
              value={totalHours}
              readOnly
              style={{ ...inputStyle, backgroundColor: '#f9fafb', fontWeight: '600' }}
            />
          </label>

          <label style={labelStyle}>
            Lunch (Minutes)
            <input
              type="number"
              min="0"
              value={entry.lunch || ''}
              onChange={e => onChange({ ...entry, lunch: e.target.value })}
              style={inputStyle}
            />
          </label>

          <label style={labelStyle}>
            Mileage (Miles)
            <input
              type="number"
              step="0.1"
              min="0"
              value={entry.mileage || ''}
              onChange={e => onChange({ ...entry, mileage: e.target.value })}
              style={inputStyle}
            />
          </label>
        </div>

        {/* Holiday */}
        <label style={labelStyle}>
          Holiday
          <input
            type="text"
            value={entry.holiday || ''}
            onChange={e => onChange({ ...entry, holiday: e.target.value })}
            style={inputStyle}
          />
        </label>

        {/* Notes */}
        <label style={labelStyle}>
          Notes
          <textarea
            value={entry.notes || ''}
            onChange={e => onChange({ ...entry, notes: e.target.value })}
            rows="3"
            style={{ ...inputStyle, resize: 'vertical' }}
          />
        </label>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem', gap: '1rem' }}>
          <button
            type="submit"
            style={{
              flex: 1,
              padding: '0.875rem',
              background: 'linear-gradient(135deg, #22c55e 0%, #0f4d2e 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            <><IcoCheck size={14}/> Save</>
          </button>
          <button
            type="button"
            onClick={onCancel}
            style={{
              flex: 1,
              padding: '0.875rem',
              background: '#4b5563',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '1rem',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditModal;

const modalStyle = {
  position: 'fixed',
  top: 0, left: 0,
  width: '100%', height: '100%',
  background: 'rgba(0,0,0,0.5)',
  display: 'flex', justifyContent: 'center', alignItems: 'center',
  zIndex: 999,
  overflowY: 'auto',
  padding: '2rem 0'
};

const formStyle = {
  background: '#fff',
  padding: '2rem',
  borderRadius: '12px',
  width: '480px',
  maxWidth: '95vw',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  maxHeight: '90vh',
  overflowY: 'auto',
  boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
};